import React from 'react'

const WhyChoose = () => {
  const features = [
    {
      title: "Expert Team",
      description: "Our team consists of highly skilled professionals with years of industry experience, ensuring top-quality solutions for your business needs."
    },
    {
      title: "Customized Solutions",
      description: "We understand that every business is unique. That's why we provide tailored solutions designed specifically to meet your requirements and goals."
    },
    {
      title: "24/7 Support",
      description: "Our dedicated support team is available round the clock to assist you with any queries or issues, ensuring smooth operations at all times."
    },
    {
      title: "Proven Track Record",
      description: "With numerous successful projects and satisfied clients, we have established a reputation for delivering excellence and driving results."
    },
    {
      title: "Cost-Effective",
      description: "We provide high-quality services at competitive prices, offering you the best value for your investment without compromising on quality."
    }
  ];

  return (
    <section style={{ backgroundColor: '#ffffff' }} className="min-h-screen py-16 px-4">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">

        {/* Right Side - Content */}
        <div className="lg:w-7/12 w-full">
          <h2 
            className="text-4xl lg:text-5xl font-bold mb-10 tracking-tight"
            style={{ color: '#1a2a3a' }}
          >
            Why Choose Kapil Tech
          </h2>

          <div className="space-y-8">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="pb-1"
                style={{ 
                  borderBottom: index !== features.length - 1 
                    ? '1px solid #eaeef2' 
                    : 'none' 
                }}
              >
                <h3 
                  className="text-xl lg:text-2xl font-semibold mb-2"
                  style={{ color: '#0f3b5e' }}
                >
                  {feature.title}
                </h3>
                <p 
                  className="text-base lg:text-lg leading-relaxed"
                  style={{ color: '#4a5b6b' }}
                >
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Left Side - Sticky Image */}
        <div className="lg:w-5/12 w-full self-center">
          <img
            src="https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/About%20US/whychoose5.jpg"
            alt="Why Choose Kapil Tech"
            className="w-full h-auto rounded-2xl object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;